import { render, staticRenderFns } from "./authority-management.pug?vue&type=template&id=a7b145d4&lang=pug&"
import script from "./authority-management.ts?vue&type=script&lang=ts&"
export * from "./authority-management.ts?vue&type=script&lang=ts&"
import style0 from "./authority-management.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports